import essentials from './essentials';
import shapingLife from './shapingLife';
import resources from './resources';

const all = [...essentials, ...shapingLife, ...resources];

export { essentials, shapingLife, all };
